import {
    GESTION_OPERATIVA_GET_LINEAS_FINANCIERAS_SUCCESS,
    GESTION_OPERATIVA_GET_LINEAS_FINANCIERAS_FAILURE,
    GESTION_OPERATIVA_GET_LINEAS_FINANCIERAS_DISMISS_ERROR,
  } from './constants'
  import { getEndpoint } from '../../common/backend/endpoints'
  import axios from 'axios'
  import _ from 'lodash/fp'
  
  export function getLineasFinancieras(marcaId, modeloID, versionID, car_lot_id, nuevo, año) {
    return (dispatch) => {
      const endpoint = getEndpoint('SIMULADOR_FINANCIERO')
  
      const promise = new Promise((resolve, reject) => {
        const body = {
          marcaId,
          modeloID,
          versionID,
          car_lot_id,
          tipoMMV: nuevo ? '0Km' : 'Usados',
          yearMMV: nuevo ? undefined : año,
        }
        const fetchUrl = encodeURI(`${endpoint}/creditsByMMV`)
        const doRequest = axios.post(fetchUrl, body)
  
        doRequest.then(
          (res) => {
            if (_.isArray(res.data.data)) {
              dispatch({
                type: GESTION_OPERATIVA_GET_LINEAS_FINANCIERAS_SUCCESS,
                data: {
                  lineas: res.data.data,
                },
              })
              resolve(res.data.data)
            } else {
              dispatch({
                type: GESTION_OPERATIVA_GET_LINEAS_FINANCIERAS_FAILURE,
                data: {
                  data: { error: res.data.data.message }
                },
              })
              resolve([])
            }
          },
          // Use rejectHandler as the second argument so that render errors won't be caught.
          (err) => {
            dispatch({
              type: GESTION_OPERATIVA_GET_LINEAS_FINANCIERAS_FAILURE,
              data: { error: err },
            })
            reject(err)
          },
        )
      })
  
      return promise
    }
  }
  
  export function dismissGetLineasFinancierasError() {
    return {
      type: GESTION_OPERATIVA_GET_LINEAS_FINANCIERAS_DISMISS_ERROR,
    }
  }
  
  export function reducer(state, action) {
    switch (action.type) {

      case GESTION_OPERATIVA_GET_LINEAS_FINANCIERAS_SUCCESS:{

        const lineasFinancieras = action.data.lineas.map((linea) => {
          const __linea = { ...linea }
          __linea.cuotasSlider = {}
          if (linea?.lines) {  
            for (const cuota of linea.lines) {
              __linea.cuotasSlider[cuota.quantity] = `${cuota.quantity}`
            }
          }
          return __linea
        })
  
        return {
          ...state,
          sale: {
            ...state.sale,
            reservation_credits: lineasFinancieras
          },
          getLineasFinancierasPending: false,
          getLineasFinancierasError: null,
        }
      }
  
      case GESTION_OPERATIVA_GET_LINEAS_FINANCIERAS_FAILURE: {
        return {
          ...state,
          getLineasFinancierasPending: false,
          getLineasFinancierasError: action.data.error,
        }
      }
  
      case GESTION_OPERATIVA_GET_LINEAS_FINANCIERAS_DISMISS_ERROR: {
        return {
          ...state,
          getLineasFinancierasError: null,
          sinLineasMessage: null,
        }
      }
  
      default:
        return state
    }
  }
  